/* El mapa se carga solo cuando alguien lo pide.
 *
 * Un iframe de Google Maps deja cookies de Google en el navegador de quien
 * entra, y eso necesita consentimiento previo (RGPD, art. 6). Es la misma razón
 * por la que el reel de Instagram va enlazado y no incrustado. Y de paso es lo
 * mejor para el móvil, que es como se abre esta página desde la mesa: hasta que
 * se pulsa, el mapa pesa cero.
 *
 * El `pb=` de maps/embed sale del diálogo de compartir y no se puede generar,
 * así que se usa `maps.google.com/maps?q=lat,lng&output=embed`, que funciona sin
 * clave de API.
 */
(function () {
  'use strict';

  function montar(caja) {
    var lat = caja.getAttribute('data-lat');
    var lng = caja.getAttribute('data-lng');
    if (!lat || !lng) return;

    var marco = document.createElement('iframe');
    marco.className = 'tmp-ed__marco';
    marco.title = 'Mapa de ' + (caja.getAttribute('data-nombre') || 'la gelatería');
    marco.loading = 'lazy';
    marco.referrerPolicy = 'no-referrer-when-downgrade';
    marco.setAttribute('allowfullscreen', '');
    marco.src = 'https://maps.google.com/maps?q=' + encodeURIComponent(lat + ',' + lng) +
                '&z=17&hl=es&output=embed';

    /* Se sustituye el botón y su nota, no la caja entera: el rótulo se queda. */
    var boton = caja.querySelector('[data-ver-mapa]');
    var nota = caja.querySelector('.tmp-ed__nota');
    if (nota) nota.remove();
    if (boton) boton.replaceWith(marco);
    else caja.appendChild(marco);
    caja.classList.add('tmp-ed__mapa--puesto');
  }

  function arrancar(raiz) {
    (raiz || document).querySelectorAll('[data-mapa]').forEach(function (caja) {
      var b = caja.querySelector('[data-ver-mapa]');
      if (!b || b.dataset.listo) return;
      b.dataset.listo = '1';
      b.addEventListener('click', function () { montar(caja); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { arrancar(); });
  /* Una sección editada en el editor de Shopify se vuelve a pintar. */
  document.addEventListener('shopify:section:load', function (e) { arrancar(e.target); });
})();
